import { Link } from 'react-router-dom';
import { EditorActivityTable } from '../components/admin/editor-activity';
import { usePageTitle } from '../hooks/usePageTitle';

// Feature 015 — Admin-only Editor Activity page (FR-015–FR-021). Internal admin
// tooling; claims the Principle VI role-gated accessibility exemption.
export function EditorActivityPage() {
  usePageTitle('Editor Activity — Hawkes Bridge');

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <Link to="/admin" className="text-sm text-primary-700 hover:underline">
        ← Back to Admin
      </Link>
      <h1 className="text-2xl font-bold text-ink mt-2 mb-2">Editor Activity</h1>
      <p className="text-sm text-ink-soft mb-6">
        Each editor's login activity over their most recent 15 active days. Expand a row to see
        login and logout times, time spent, and the pages they visited per date.
      </p>
      <EditorActivityTable />
    </div>
  );
}
